module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IArs4c6QAAAEVQTFRFAAAAIGDvKGjvLGjrKWnsKmjsK2ntLGjtLGjrK2jsLGjsLGnrK2jrK2jsK2jsLGfsLGnsKmbsLGjsLGjtK2jsK2nsLGns6RDwywAAABV0Uk5TABAgQFBgcH+AsL/A0N/n7+/w8Pv+eKAsFgAAAG5JREFUKM/VkEESgCAIAFHTjDKNiv8/NTOryfFYh/YADAscAMg0nNBQIAL1EQqiEPaY1WyvDuLo/bTwnOBl8n5EbGFIp1e+OMoh7qh7/TyrUn5fkAEwoSL2aPk3oot/1923v6oJhw9cFpK4gCTABjmHDWcsby3tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/fj-dele.png
// module id = EVup
// module chunks = 0